import React, { memo } from "react";
import { Badge } from "react-bootstrap";
import { ConcerningLevelLibrary } from "../containers/WebReportV1/helperFunctions";

const ConcerningLevelBadge = ({ concerningLevel, itemType }) => {
  const concerningLevelData =
    ConcerningLevelLibrary?.[itemType]?.[concerningLevel || 0] || {};

  return (
    <Badge className={`concern-level-badge ${concerningLevelData.colorRule}`}>
      {concerningLevelData.name}
    </Badge>
  );
};

export default memo(ConcerningLevelBadge);
